import { useSelector } from '@legendapp/state/react';
import { useTranslation, Trans } from 'react-i18next';
import { Keyboard } from 'lucide-react';
import { ui$, closeShortcutsModal } from '../store/ui$';
import { SHORTCUT_GROUPS } from '../config/shortcuts.config';
import { Dialog, ICON_SIZE } from '../design-system';
import './ShortcutsModal.css';

/**
 * Keyboard Shortcuts Cheat Sheet Modal
 * Shows all available keyboard shortcuts grouped by context
 */
const ShortcutsModal = () => {
  const { t } = useTranslation('common');
  const isOpen = useSelector(() => ui$.shortcutsModalOpen.get());

  // Custom title with icon
  const titleContent = (
    <div className="shortcuts-modal-title">
      <Keyboard size={ICON_SIZE.lg} />
      <span>{t('shortcuts.title')}</span>
    </div>
  );

  // Footer with keyboard hint
  const footerContent = (
    <span className="shortcuts-hint">
      <Trans
        i18nKey="shortcuts.pressToClose"
        components={{ kbd: <kbd className="shortcut-key shortcut-key--small" /> }}
      />
    </span>
  );

  return (
    <Dialog
      isOpen={isOpen}
      onClose={closeShortcutsModal}
      title={titleContent}
      size="lg"
      className="shortcuts-modal-container"
      footer={footerContent}
      centered
    >
      <div className="shortcuts-modal-content">
        {SHORTCUT_GROUPS.map((group, groupIndex) => (
          <div key={groupIndex} className="shortcuts-group">
            <h3 className="shortcuts-group-title">
              {t(group.titleKey)}
            </h3>
            <div className="shortcuts-list">
              {group.shortcuts.map((shortcut, shortcutIndex) => (
                <div key={shortcutIndex} className="shortcut-item">
                  <div className="shortcut-keys">
                    {shortcut.displayKeys.map((key, keyIndex) => (
                      <span key={keyIndex}>
                        <kbd className="shortcut-key">{key}</kbd>
                        {keyIndex < shortcut.displayKeys.length - 1 && (
                          <span className="shortcut-key-separator">/</span>
                        )}
                      </span>
                    ))}
                  </div>
                  <span className="shortcut-description">
                    {t(shortcut.i18nKey)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Dialog>
  );
};

export default ShortcutsModal;
